var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"id":"mini","element-loading-text":"跳转中。。。","element-loading-background":"rgba(0, 0, 0, 0.8)"}})
}
var staticRenderFns = []

export { render, staticRenderFns }